/**
 * image-card-slider.js
 * 横向卡片滑动组件 — 支持变宽卡片、拖拽 / 触控 / 按钮导航
 */
(function () {
  document.querySelectorAll('.ics').forEach(initSlider);

  function initSlider(root) {
    const viewport = root.querySelector('.ics-slider-viewport');
    const track = root.querySelector('[data-slider-track]');
    const prevBtn = root.querySelector('[data-prev]');
    const nextBtn = root.querySelector('[data-next]');
    const progressBar = root.querySelector('[data-progress]');

    if (!viewport || !track) return;

    const cards = Array.from(track.querySelectorAll('.ics-card'));
    if (cards.length === 0) return;

    let currentX = 0;
    let dragging = false;
    let startX = 0;
    let startOffset = 0;
    let lock = null;

    // Prevent native image drag
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - viewport.clientWidth);
    }

    function getOffsets() {
      // Snap points: start (text view) + left edge of each card
      var offsets = [0];
      cards.forEach(function (card) { offsets.push(card.offsetLeft); });
      return offsets;
    }

    function clamp(x) {
      return Math.min(0, Math.max(-getMaxScroll(), x));
    }

    function setTransform(x) {
      track.style.transform = 'translateX(' + x + 'px)';
    }

    function settle(x) {
      currentX = clamp(x);
      setTransform(currentX);
      updateUI();
    }

    function nextSnap() {
      var pos = -currentX;
      var offsets = getOffsets();
      for (var i = 0; i < offsets.length; i++) {
        if (offsets[i] > pos + 1) return clamp(-offsets[i]);
      }
      return clamp(-getMaxScroll());
    }

    function prevSnap() {
      var pos = -currentX;
      var offsets = getOffsets();
      var target = 0;
      for (var i = 0; i < offsets.length; i++) {
        if (offsets[i] < pos - 1) target = offsets[i];
        else break;
      }
      return clamp(-target);
    }

    function nearestSnap() {
      var pos = -currentX;
      var offsets = getOffsets();
      var best = offsets[0];
      var bestDist = Infinity;
      for (var i = 0; i < offsets.length; i++) {
        var d = Math.abs(offsets[i] - pos);
        if (d < bestDist) { bestDist = d; best = offsets[i]; }
      }
      return clamp(-best);
    }

    function updateUI() {
      var max = getMaxScroll();
      var pos = -currentX;

      if (progressBar) {
        progressBar.style.width = (max > 0 ? (pos / max) * 100 : 0) + '%';
      }
      if (prevBtn) prevBtn.disabled = pos <= 1;
      if (nextBtn) nextBtn.disabled = pos >= max - 1;
    }

    // Button navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { settle(prevSnap()); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { settle(nextSnap()); });
    }

    // Drag / swipe support
    function onDown(e) {
      if (e.buttons !== undefined && e.buttons !== 1 && e.pointerType === 'mouse') return;
      dragging = true;
      lock = null;
      startX = e.clientX;
      startOffset = currentX;
      track.classList.add('is-dragging');
      viewport.classList.add('is-dragging');
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
    }

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - (e._startY || e.clientY);

      if (lock === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        lock = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
      }

      if (lock === 'y') {
        onUp(e, true);
        return;
      }

      if (lock === 'x') {
        setTransform(clamp(startOffset + dx));
        e.preventDefault();
      }
    }

    function onUp(e, cancel) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      viewport.classList.remove('is-dragging');
      if (track.releasePointerCapture) track.releasePointerCapture(e.pointerId);

      if (cancel) {
        settle(currentX);
        return;
      }

      var dx = e.clientX - startX;
      var threshold = 60;
      currentX = clamp(startOffset + dx);

      if (dx < -threshold) {
        settle(nextSnap());
      } else if (dx > threshold) {
        settle(prevSnap());
      } else {
        settle(nearestSnap());
      }
    }

    viewport.addEventListener('pointerdown', onDown, { passive: true });
    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', function (e) { onUp(e, false); }, { passive: true });
    window.addEventListener('pointercancel', function (e) { onUp(e, true); }, { passive: true });

    // Resize handling
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { settle(nearestSnap()); }, 100);
    });

    // Init
    updateUI();
  }
})();

